import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@material-ui/core';
import { Provider } from 'react-redux';
import { store } from './_helpers/store';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

const theme = createTheme({
  palette: {
    primary: {
      light: '#72BF44',
      main: '#447329',
      dark: '#2E4C1B',
      contrastText: '#fff',
    }
  },
});


document.addEventListener("wheel", function(event){
  if(document.activeElement?.classList.contains("noscroll")) {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
});

Sentry.init({
  dsn: "https://3c62fa80c1de4e288ab9043d31098936@o1029242.ingest.sentry.io/5996142",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
